import * as Raven from 'raven-js';
import {ErrorHandler} from '@angular/core';
declare var DKPROD: boolean;

export class RavenErrorHandler implements ErrorHandler {
    handleError(err:any) : void {
        if (DKPROD) {
            if (Raven) {
                if (Raven.captureException) {
                   Raven.captureException(err.originalError);
                }
            }
        } else {
            console.log(err);
        }
    }
}
